module.exports = __webpack_public_path__ + "95eef8bb6afe10255f9d2eff806d7e2d.svg";


//////////////////
// WEBPACK FOOTER
// ./react.svg
// module id = 492
// module chunks = 0